// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PortfolioDashboard/navigationPages/backtest/backtest.css
// module id = 1497
// module chunks = 0